/**
 * Header Queries - Extended with siteId lookup
 *
 * @override
 * - Re-exports all base header queries from @amblique/contentful
 * - Adds getHeaderBySiteId queries (base, default, full variants)
 */

import gql from 'graphql-tag';

import {
  BaseHeaderFragment,
  HeaderFragment,
  FullHeaderFragment,
} from '@amblique/contentful/app/contentful/fragments/header';

// Re-export all base queries
export * from '@amblique/contentful/app/contentful/queries/header.queries';

/**
 * Get a single Header by siteId (base - scalars only)
 */
export const getBaseHeaderBySiteId = gql`
  ${BaseHeaderFragment}

  query GetBaseHeaderBySiteId($siteId: String!, $locale: String!, $preview: Boolean) {
    headerCollection(
      where: { siteId: $siteId }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...BaseHeaderFragment
      }
    }
  }
`;

/**
 * Get a single Header by siteId (standard - 1 level deep)
 */
export const getHeaderBySiteId = gql`
  ${HeaderFragment}

  query GetHeaderBySiteId($siteId: String!, $locale: String!, $preview: Boolean) {
    headerCollection(
      where: { siteId: $siteId }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...HeaderFragment
      }
    }
  }
`;

/**
 * Get a single Header by siteId (full - 2 levels deep)
 */
export const getFullHeaderBySiteId = gql`
  ${FullHeaderFragment}

  query GetFullHeaderBySiteId($siteId: String!, $locale: String!, $preview: Boolean) {
    headerCollection(
      where: { siteId: $siteId }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...FullHeaderFragment
      }
    }
  }
`;
